import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCurrentUser } from "@sprout/client-graphql";
import { stringify } from "query-string";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { Button } from "sprout-ui-dom";
import { ArrowBackIosOutlined, EcoOutlined as BaseEcoOutlined } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled, { createGlobalStyle } from "styled-components";
const Override = createGlobalStyle`
  body {
    background: ${themeGet("colors.white.100")} !important;
  }
`;
const EcoOutlined = styled(BaseEcoOutlined)`
  width: 60px;
  height: 60px;
`;
const AppBarLandingMaxWidth = styled(Flex)`
  gap: 16px;
`;
const AppBarLandingWrapper = styled(Flex)`
  ::after {
    position: absolute;
    top: 100%;
    left: 0;
    content: "";
    width: 100%;
    height: 288px;
    background: linear-gradient(
      180deg,
      rgba(253, 246, 240, 1) 0,
      rgba(253, 246, 240, 0) 100%
    );
    z-index: -1;
  }
`;
const AppBarLandingBackButton = styled(Button)`
  ${media.up("small")} {
    position: fixed;
    height: 48px;
    z-index: 1;
  }
`;
const AppBarLandingButtonsWrapper = styled(Flex)`
  gap: 16px;
`;
const LoginButton = styled(Button)`
  color: ${themeGet("colors.primary")};
  font-size: ${themeGet("fontSizes.3")}px;
  border-width: 2px;

  :not(:disabled) {
    ${media.target("pointer")} {
      :hover {
        color: ${themeGet("colors.white.100")};
        background: ${themeGet("colors.blue.500")};
        border-color: ${themeGet("colors.blue.500")};
      }

      :active {
        background: #2738bf;
        border-color: #2738bf;
      }
    }
  }
`;
const AppBarLanding = ()=>{
    const { pathname  } = useLocation();
    const currentUser = useCurrentUser();
    const isFeaturePage = !!useRouteMatch({
        exact: true,
        path: "/features/:feature"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Override, {}),
            /*#__PURE__*/ _jsx(AppBarLandingWrapper, {
                position: "relative",
                pt: 4,
                pb: "64px",
                px: 3,
                bg: "#fdf6f0",
                justifyContent: "center",
                children: /*#__PURE__*/ _jsxs(AppBarLandingMaxWidth, {
                    width: "100%",
                    maxWidth: "1400px",
                    flexDirection: [
                        "column",
                        "row"
                    ],
                    justifyContent: [
                        null,
                        "space-between"
                    ],
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            alignItems: "center",
                            as: Link,
                            to: "/",
                            children: [
                                /*#__PURE__*/ _jsx(EcoOutlined, {}),
                                /*#__PURE__*/ _jsx(Text, {
                                    as: "span",
                                    fontSize: "34px",
                                    fontWeight: "bold",
                                    ml: 1,
                                    children: "Sprout"
                                })
                            ]
                        }),
                        isFeaturePage ? /*#__PURE__*/ _jsx(Flex, {
                            flex: "1",
                            minWidth: "0",
                            justifyContent: "flex-end",
                            height: "48px",
                            children: /*#__PURE__*/ _jsxs(AppBarLandingBackButton, {
                                variant: "dark-purple",
                                as: Link,
                                to: "/features",
                                children: [
                                    /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {}),
                                    /*#__PURE__*/ _jsx(Text, {
                                        as: "span",
                                        ml: 0,
                                        children: "Back to features"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ _jsxs(AppBarLandingButtonsWrapper, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    textDecoration: "underline",
                                    as: Link,
                                    to: "/pricing",
                                    color: "blue.500",
                                    fontWeight: "bold",
                                    fontSize: 3,
                                    children: "Pricing"
                                }),
                                /*#__PURE__*/ _jsx(LoginButton, {
                                    variant: "outline",
                                    as: Link,
                                    to: currentUser ? "/" : {
                                        pathname: "/login",
                                        search: stringify({
                                            next: pathname
                                        })
                                    },
                                    children: currentUser ? "Launch Sprout" : "Login"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default AppBarLanding;
